import { Card } from "../../models/card";
import { cards } from "../../state";
import { Rock } from "../resources/rock";
import { forceUpdate, dropCard } from "../..";
export class RockMaker extends Card {
}
RockMaker.displayName = "Rock";
RockMaker.artUrl = "./assets/cards/rock.jpg";
RockMaker.effect = {
    callback: (card) => {
        let newPos = { x: card.position.x - 8, y: card.position.y - 180 };
        const newCard = new Rock(newPos);
        cards.push(newCard);
        forceUpdate();
        dropCard(newCard);
    },
    description: "Get a Rock",
    needsFeedback: false,
};
